import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDywn--gHCXQIVpXVv6tPt5Tw0hNUZ_fh8",
  authDomain: "nexawave-4d18a.firebaseapp.com",
  projectId: "nexawave-4d18a",
  storageBucket: "nexawave-4d18a.firebasestorage.app",
  messagingSenderId: "271536649072",
  appId: "1:271536649072:web:5382d7cea1a6cb718595b5",
  measurementId: "G-M2CKJJLZ4V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth with custom settings
export const auth = getAuth(app);

// Toggle with REACT_APP_OTP_TEST_MODE=true for local testing with Firebase test phone numbers.
export const isOtpTestMode = process.env.REACT_APP_OTP_TEST_MODE === 'true';

// Enable Firebase debug logging
if (process.env.NODE_ENV === 'development') {
  // Enable debug logging for development
  console.log('Firebase Debug: Enabling debug logging');
  // Set localStorage for debug logging
  if (typeof window !== 'undefined') {
    localStorage.setItem('debug', 'firebase:*');
  }
}

// Global function to enable Firebase debug logging from browser console (development only)
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  window.enableFirebaseDebug = () => {
    localStorage.setItem('debug', 'firebase:*');
    console.log('Firebase debug logging enabled. Refresh the page to apply changes.');
  };

  window.disableFirebaseDebug = () => {
    localStorage.removeItem('debug');
    console.log('Firebase debug logging disabled. Refresh the page to apply changes.');
  };
}

// Configure reCAPTCHA settings
auth.settings = {
  appVerificationDisabledForTesting: isOtpTestMode,
};

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;
